// The name shown in the browser tab for each screen, with the wording of the
// menu. Never a contact's name: tab titles end up in the browser history.
export const ROUTE_TITLE_KEYS: Record<string, string> = {
  ProfileHome: 'webNav.myProfile',
  ProfileEdit: 'webNav.myProfile',
  ProfileMemories: 'webNav.myProfile',
  ProfileAddMemory: 'webNav.myProfile',
  ProfileShowMemory: 'webNav.myProfile',
  ProfileAlbumMemories: 'webNav.myProfile',
  NotesList: 'menuItems.notes',
  EditNote: 'menuItems.notes',
  CategoriesList: 'menuItems.categories',
  CategoryDetails: 'menuItems.categories',
  AddCategory: 'menuItems.categories',
  EditCategory: 'menuItems.categories',
  HashtagsList: 'menuItems.hashtags',
  HashtagDetails: 'menuItems.hashtags',
  AddHashtag: 'menuItems.hashtags',
  EditHashtag: 'menuItems.hashtags',
  RelationalColorsList: 'menuItems.relationalColors',
  EditRelationalColor: 'menuItems.relationalColors',
  CalendarMain: 'menuItems.appointments',
  AddEvent: 'menuItems.appointments',
  Birthdays: 'menuItems.birthdays',
  KeepContactMain: 'menuItems.keepContact',
  AddKeep: 'menuItems.keepContact',
  ScheduledMessagesList: 'menuItems.scheduledMessages',
  CreateScheduledMessage: 'menuItems.scheduledMessages',
  ComposeMessage: 'menuItems.scheduledMessages',
  QRCode: 'menuItems.qrCode',
  Scan: 'menuItems.qrCode',
  Settings: 'menuItems.settings',
  NotificationSettings: 'menuItems.settings',
  Subscription: 'settings.subscription',
  Map: 'menuItems.maps',
  Graph: 'menuItems.graph',
  Nearby: 'menuItems.nearby',
  ImportContacts: 'menuItems.importContacts',
  ClassifyContacts: 'menuItems.classifyProfiles',
  MergeContacts: 'menuItems.mergeProfiles',
  AddConversation: 'tabNavigation.messages',
  Conversation: 'tabNavigation.messages',
  GroupConversation: 'tabNavigation.messages',
  EventsList: 'menuItems.events',
  EventCreate: 'menuItems.events',
  EventManage: 'menuItems.events',
  EventEdit: 'menuItems.events',
  EventCheckIn: 'menuItems.events',
  EventCheckInScan: 'menuItems.events',
  OrganizerRequest: 'menuItems.events',
  OrganizerStats: 'menuItems.events',
  MyTicket: 'menuItems.events',
  AdminHome: 'menuItems.admin',
  AdminOrganizers: 'menuItems.admin',
  AdminAddOrganizer: 'menuItems.admin',
  AdminOrganizerDetail: 'menuItems.admin',
  AdminRequests: 'menuItems.admin',
  AdminEvents: 'menuItems.admin',
  AdminEventDetail: 'menuItems.admin',
  AdminSettings: 'menuItems.admin',
  MenuMain: 'tabNavigation.profile',
}

const APP_NAME = 'KeepTouch'

// « Notes – KeepTouch »; plain « KeepTouch » on the login pages and wherever
// no name is known. The tabs (Contacts, Messages…) carry their own title.
export const formatDocumentTitle =
  (t: (key: string) => string) =>
  (options?: Record<string, any>, route?: { name: string }): string => {
    const key = route ? ROUTE_TITLE_KEYS[route.name] : undefined
    const label = options?.title ?? (key ? t(key) : undefined)
    return label ? `${label} – ${APP_NAME}` : APP_NAME
  }
